import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_PROPERTIES_PAGE_SIZE,
  buildOwnerEmailLookupRequest,
  buildOwnerUidLookupRequest,
  buildPropertiesBrowseRequest,
  buildPropertyIdLookupRequest,
} from './propertiesListRequest';

export {
  ADMIN_PROPERTIES_PAGE_SIZE,
  buildOwnerEmailLookupRequest,
  buildOwnerUidLookupRequest,
  buildPropertiesBrowseRequest,
  buildPropertyIdLookupRequest,
};

/**
 * Admin properties list. Callables only — no client Firestore reads of properties.
 * @param {{
 *   mode: string,
 *   pageSize?: number,
 *   pageToken?: string,
 *   propertyId?: string,
 *   uid?: string,
 *   email?: string,
 * }} request
 */
export async function listAdminProperties(request) {
  const fn = httpsCallable(functions, 'listAdminProperties');
  const { data } = await fn(request);
  return data;
}

/**
 * Property 360 payload. Callables only.
 * @param {string} propertyId
 */
export async function getAdminProperty(propertyId) {
  const fn = httpsCallable(functions, 'getAdminProperty');
  const { data } = await fn({ propertyId });
  return data;
}
